import { confirmResetPassword, resetPassword } from "aws-amplify/auth";
import { ResetPasswordSchema } from "@validators/auth";
import { authBus } from "../AuthEvents";

export const resetPasswordConfirmation = async ({ code, email, password }: ResetPasswordSchema) => {
  try {
    // 1. Functional API call
    await confirmResetPassword({
      username: email,
      confirmationCode: code.trim(),
      newPassword: password,
    });

    authBus.emitMessage("Your password has changed. Login with your new password", "success");
    authBus.emitTransition("login");
  } catch (error: any) {
    let userMessage = "An error occurred. Please try again.";

    switch (error.name) {
      case "CodeMismatchException":
        userMessage = "Incorrect Verification Code. Please try again.";
        break;
      case "ExpiredCodeException":
        await resetPassword({ username: email });
        userMessage = "Code expired. A new code has been sent to your email.";
        break;
      case "InvalidPasswordException":
        userMessage = "Your password doesn't meet the security policy.";
        break;
      case "TooManyFailedAttemptsException":
        userMessage = "Too many attempts. Please wait 10 minutes.";
        break;
      case "LimitExceededException":
      case "TooManyRequestsException":
        userMessage = "Too many requests. Please wait a minute.";
        break;
      default:
        userMessage = error.message || userMessage;
        break;
    }

    authBus.emitMessage(userMessage, "error");
  }
};
